import { ArrowRight } from 'lucide-react';
import type React from 'react';
import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Spinner from '@/components/shared/Spinner';
import { Button } from '@/components/ui/button';
import apiService from '@/services/apiService';

const InBehandelingPage = (): React.JSX.Element => {
	const { t } = useTranslation();
	const { id } = useParams<{ id: string }>();
	const [activationUrl, setActivationUrl] = useState<string | null>(null);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		if (!id) {
			setIsLoading(false);
			return;
		}

		let cancelled = false;
		apiService.activation
			.fetch(id)
			.then((data) => {
				if (cancelled) return;
				setActivationUrl(data?.activation_redirect_url ?? null);
			})
			.catch((err) => {
				console.error('Error fetching VI activation URL:', err);
			})
			.finally(() => {
				if (!cancelled) setIsLoading(false);
			});

		return () => {
			cancelled = true;
		};
	}, [id]);

	const handleOpenViPortal = () => {
		if (!activationUrl || !/^https?:\/\//i.test(activationUrl)) return;
		window.open(activationUrl, '_blank', 'noopener,noreferrer');
	};

	return (
		<section className="flex grow items-center">
			<div className="container mx-auto px-4 pb-20">
				<div className="lg:w-7/12 mx-auto text-center">
					<h1 className="text-4xl font-bold mb-10">{t('common.inBehandeling.title')}</h1>
					<p className="text-xl mb-10 leading-loose">
						<Trans i18nKey="common.inBehandeling.description" components={{ br: <br /> }} />
					</p>
					<div className="flex flex-col sm:flex-row gap-3 justify-center">
						{isLoading && <Spinner size="md" variant="primary" className="mx-auto" />}
						{!isLoading && activationUrl && (
							<Button
								type="button"
								variant="default"
								size="lg"
								className="px-5 py-3 text-base font-medium"
								onClick={handleOpenViPortal}
								iconRight={<ArrowRight className="w-4 h-4 ml-2" />}
								data-testid="vi-portal-button"
							>
								{t('common.inBehandeling.viPortalButton')}
							</Button>
						)}
					</div>
				</div>
			</div>
		</section>
	);
};

export default InBehandelingPage;
